import { useEffect, useRef, useCallback } from 'react';

/**
 * Custom hook to use Broadcast Channel for inter-tab communication.
 *
 * @param channelName - Name of the Broadcast Channel
 * @param onMessage - Optional callback function to handle incoming messages
 */
export function useBroadcastChannel<T>(
	channelName: string,
	onMessage?: (message: T) => void
) {
	const bcRef = useRef<BroadcastChannel | null>(null);

	useEffect(() => {
		const bc = new BroadcastChannel(channelName);
		bcRef.current = bc;

		if (typeof onMessage === 'function') {
			bc.onmessage = (event) => onMessage(event.data as T);
		}

		return () => {
			bc.close();
			bcRef.current = null;
		};
	}, [channelName, onMessage]);

	const postMessage = useCallback((msg: T) => {
		bcRef.current?.postMessage(msg);
	}, []);

	return { postMessage };
}
